<template>
<div :key='$route.params.fund_code'>
    <FundInfo />
    <div class="az-content-body">
       <!-- <div v-if="isAdShow"><AdviserInfo /></div> -->
        <div class="az-content az-content-dashboard-fifteen">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div><!-- az-content -->
    </div><!-- az-content-body --> 
</div>
</template>
<script>
export default {
  name: 'FundPanel',
  components: {
    FundInfo:()=>import('../components/FundInfo.vue'),
  },
  
  
  
}
</script>